
    import "src/app/AppWms/SettingsPage/index.module.scss?farm_css_modules";
    
    export default {"settingsPageContainer": `settingsPageContainer-54c01c53`}
    